<template>
        <div class="animated fadeIn">
           <spinner v-if="loading"/>
           <b-card>
              <div slot="header">
                 <strong>Search GRN</strong>
              </div>
              <b-row>
                    <b-col sm="2">
                        <b-form-group>
                            <label for="grn_num">GRN No</label>
                                <b-form-input type="text" id="grn_num" v-model="filter.grn_num"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="3">
                        <b-form-group>
                            <label for="po_num">PO No</label>
                                <b-form-input type="text" id="po_num" v-model="filter.po_num"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="2">
                        <b-form-group>
                            <label for="grn_date_start">Date Start</label>
                                <b-form-input type="date" v-model="filter.date_start"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="2">
                        <b-form-group>
                            <label for="grn_date_end">Date End</label>
                                <b-form-input type="date" v-model="filter.date_end"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="3">
                        <b-form-group>
                            <label for="fulfilment_status">Fulfilment Status</label>
                                <b-form-select id="fulfilment_status" v-model="filter.fulfilment_status"
                                      :plain="true"
                                      :options="['','PARTIAL','UNFULFILLED', 'FULFILLED', 'MANUAL CLOSED']"
                                      value="">
                                </b-form-select>
                        </b-form-group>
                    </b-col>
              </b-row>
              <div slot="footer">
                 <b-button type="submit" size="lg" variant="primary" @click="search">Search</b-button>
                 &nbsp;&nbsp;
                 <b-button type="submit" size="lg" variant="success" @click="createNew">New GRN</b-button>
              </div>
           </b-card>
           <b-row v-if="this.searchResults.length > 0 && !loading">
                <b-col sm="12">
                    <b-card>
                        <div slot="header">
                            <strong>Search Results</strong>
                        </div>
                        <div class="table-responsive">
                            <b-table class="table-hover" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :fields="searchResultsFields" :current-page="currentPage" 
                                :per-page="perPage" @row-clicked="rowClick" :items="searchResults" >
                            </b-table>
                        </div>
                        <nav>
                            <b-pagination :total-rows="getRowCount(searchResults)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
                        </nav>
                        <div slot="footer">
                            <exportExcel
                              class   = "btn btn-primary btn-lg"
                              size ="lg"
                              :data   = "searchResults"
                              :fields = "exportHeaders"
                              name    = "grn.xls">
                              Export to Excel
                          </exportExcel>
                          &nbsp;&nbsp;
                          <b-button type="button" size="lg" variant="success" @click="print">Print</b-button>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
            <b-row v-else-if="noResults && !loading" >
                <b-col sm="12">
                  <div align="center">
                    <strong>No GRN Found</strong>
                  </div>                    
                </b-col>
            </b-row>
        </div>
</template>
<script>
import spinner from '@/components/Spinner.vue'
import axios from 'axios'
import {apiPoSearch} from '@/functions/common.vue'
import exportExcel from 'vue-json-excel'

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.fonts = {
      "ukai": {
         normal: 'ukai.ttf',
          bold: 'ukai.ttf',
          italics: 'ukai.ttf',
           bolditalics: 'ukai.ttf'
      },
   };
export default
{
  components: {spinner,exportExcel},
  props: 
  {
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data () {
  return {
    apiPoSearch: apiPoSearch,
    loading: false,
    filter: {
      grn_num: '',
      po_num: '',
      date_start: '',
      date_end: '',
      fulfilment_status:''
    },
    seen :false,
    fulfilment_status: '',
    searchResults: [],
    searchResultsFields: [
      {key: 'country_id', label: 'Country',sortable: true},
      {key: 'location_name' ,label: 'Location'},
      {key: 'last_grn_num' ,label: 'Last GRN',sortable: true},
      {key: 'last_grn_date' ,label: 'GRN Date'},
      {key: 'po_date' ,label: 'PO Date'},
      {key: 'po_num' ,label: 'PO No'},
      {key: 'supplier_name' ,label: 'Supplier'},
      {key: 'po_type' ,label: 'Type'},
      {key: 'po_fulfilment_status' ,label: 'Fulfilment Status'},
    ],
    currentPage: 1,
    perPage: 20,
    totalRows: 0,
    noResults: false,
    exportHeaders:
        {
          'Country': 'country_id',
          'Location': 'location_name',
          'Last GRN':'last_grn_num',
          'Last GRN Date':'last_grn_date',
          'PO Date':'po_date',
          'PO No':'po_num',
          'Supplier':'supplier_name',
          'Type':'po_type',
          'Fulfilment Status':'po_fulfilment_status',
        },
  }
  },
  methods:
  {
    print()
        {
          var rows = []
          var row = []
          var date = new Date()
          rows.push(['Country',
          'Location',
          'Last GRN',
          'Last GRN Date',
          'PO Date',
          'PO No',
          'Supplier',
          'Type',
          'Fulfilment Status'
          ])

          for (let key in this.searchResults)
          {
            var data = this.searchResults[key]
            row = [data.country_id, data.location_name,data.last_grn_num, data.last_grn_date,data.po_date, data.po_num, data.supplier_name, data.po_type, data.po_fulfilment_status]
            rows.push(row)
          }
          var dd = {
            header:{ text: 'Good Receive Note List generated on'+ " "+ date, margin: [ 5, 10, 10, 20 ],alignment: 'center',fontSize:7 },
            pageSize: 'A4',
            pageOrientation: 'landscape',
          
            // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
            pageMargins: [30, 30, 30, 20 ],
            defaultStyle: {
            font: 'ukai'
          },
            content: [
              {
                fontSize: 8,
                layout: 'lightHorizontalLines', // optional
                
                table: {
                  // headers are automatically repeated if the table spans over multiple pages
                  // you can declare how many rows should be treated as headers
                  headerRows: 1,
                  widths: [ 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto' ,'auto'],

                  body: 
                    rows
                  
                }
              }
            ]
          };

          pdfMake.createPdf(dd).open();
        },
    createNew ()
    {
        localStorage.setItem("grn_new.po_num","")
        this.$router.push({ name: 'Goods Received Note (GRN)', params: { grnNum: '_new' }})
    },
    rowClick(item, index)
    { 
        localStorage.setItem("grn_new.po_num", item.po_num)
        this.$router.push({ name: 'Goods Received Note (GRN)', params: { grnNum: '_new' }})
        
    },
    getRowCount (list) 
    {
        return list.length
    },
    search ()
    {
        this.loading = true
        this.seen =true
        var sf =
          [
            "grns_list LIKE " + this.filter.grn_num
            ,"po_num LIKE " + this.filter.po_num
            ,"po_date >= " + this.filter.date_start
            ,"po_date <= " + this.filter.date_end
            ,"po_fulfilment_status = " + this.filter.fulfilment_status
          ]        

        axios.post(apiPoSearch, sf)
            .then (res => 
            {
                return res
            })
            .then (data =>
            {
                const resultArray = []
                const myData = data.data.data.list
                for (let key in myData)
                {
                    var date = myData[key].po_date
                    var lastGrnDate = myData[key].last_grn_date
                    var lastGrn = myData[key].last_grn_num
                    if( lastGrn == null)
                    {
                        lastGrn = '-'
                    }
                    date = new Date(date)
                    var lastGrnDateResult
                    var result = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/'+  ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
                    if (lastGrnDate != null)
                    {
                        lastGrnDate = new Date(lastGrnDate)
                        var lastGrnDateResult =  "" + (lastGrnDate.getDate() > 9 ? '' : '0') + lastGrnDate.getDate() + '/'+  ((lastGrnDate.getMonth() + 1) > 9 ? '' : '0') + (lastGrnDate.getMonth() + 1) + '/' + lastGrnDate.getFullYear()
                    }
                    else
                    {
                        lastGrnDateResult = '-'
                    }
                    myData[key].po_date=result
                    myData[key].last_grn_date = lastGrnDateResult
                    myData[key].last_grn_num = lastGrn
                    resultArray.push(myData[key])
                    this.loading = false
                }
                this.searchResults = resultArray
                
                if(this.searchResults.length ==0)
                {
                    this.loading = false
                    this.noResults =true
                }
            })
            .catch(error => console.log(error))
        }
    }
}
</script>
<style>
    .main {overflow-x: overlay;overflow-y: overlay;overflow:hidden;}
</style>


// WEBPACK FOOTER //
// src/views/grn/grns.vue